import React, { useState, useRef, useEffect } from "react";
import Accordion from 'react-bootstrap/Accordion';
import constants from '../../Components/Services/constant';
import Footer from "../../Components/Footer";
import Header from "../../Components/Header";
import { ApiService } from "../../Components/Services/apiservices";

let apiServices = new ApiService();

function AboutUs() {
  const [showMore, setShowMore] = useState(false);
  const readMoreRef = useRef(null);
  const [pageData, setPageData] = useState({});

  useEffect(() => {
    const dataString = { page_url: "about" };
    apiServices.pagePostRequest(dataString)
      .then((res) => {
        if (res.data.status === "success" && res.data.pageData) {
          setPageData(res.data.pageData);
        }
      })
      .catch((err) => {
        console.error("Error fetching about page data:", err);
      });
  }, []);

  const handleShowLess = () => {
    setShowMore(false);
    setTimeout(() => {
      if (readMoreRef.current) {
        readMoreRef.current.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
    }, 100);
  };

  return (
    <div className="about-us-page homepage2-wrapper">
      <Header />
      <style>
        {`
            .about-banner-responsive {
                background-image: url('${pageData?.page_header_image ? `${constants.IMAGE_URL}${pageData.page_header_image}` : "/assets/img/food/About-Banner-desktop.webp"}');
            }
            @media (max-width: 768px) {
                .about-banner-responsive {
                    background-image: url('${pageData?.metadata?.banner_mobile_image ? `${constants.IMAGE_URL}${pageData.metadata.banner_mobile_image}` : "/assets/img/food/About-Banner-Mobile.webp"}');
                }
            }
        `}
      </style>
      <div
        className="banner-header section-padding bg-position-bottom valign bg-img bg-fixed about-banner-responsive"
        data-overlay-dark="3"
        style={{
          backgroundSize: "cover",
          backgroundPosition: "100%",
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-md-12 text-center caption mt-90">
              <h1 dangerouslySetInnerHTML={{ __html: pageData?.metadata?.page_title || 'Welcome to Chokhi Dhani' }} />
            </div>
          </div>
        </div>
      </div>

      {/* Story Section */}
      <section
        className="our-story-section text-center"
        style={{ paddingTop: "80px" }}
      >
        <div className="container">
          <div className="story-text-container-full mb-5">
            <div className="story-description" dangerouslySetInnerHTML={{ __html: pageData?.metadata?.story_description_1 || 'At Chokhi Dhani London, we bring the rich heritage, vibrant culture, and authentic flavours of India to the heart of London. Inspired by the renowned Chokhi Dhani legacy that has celebrated Indian hospitality for over 34 years, our restaurant offers a unique dining experience where traditional Rajasthani charm meets contemporary elegance. From handcrafted interiors and warm hospitality to carefully curated regional Indian cuisine, every detail is designed to transport guests on a memorable culinary journey through India.' }} />
          </div>
        </div>

        <div className="container-fluid px-0 mb-5">
          <div className="story-slider-fullwidth">
            <picture>
              <source
                media="(max-width: 991px)"
                srcSet={pageData?.metadata?.about_mobile_image ? `${constants.IMAGE_URL}${pageData.metadata.about_mobile_image}` : "/assets/img/food/About-Cd-Banner-Mobile.webp"}
              />
              <img
                src={pageData?.metadata?.about_image ? `${constants.IMAGE_URL}${pageData.metadata.about_image}` : "/assets/img/food/About-CD-Desktop-Banner.webp"}
                alt="Chokhi Dhani London dining room"
                className="img-fluid full-width-img"
                style={{ height: "auto", width: "100%" }}
              />
            </picture>
          </div>
        </div>

        <div className="container mb-2 text-center" ref={readMoreRef}>
          {!showMore ? (
            <button
              onClick={() => setShowMore(true)}
              className="btn-story-readmore"
            >
              Read More
            </button>
          ) : (
            <div className="read-more-content" style={{ marginTop: "40px" }}>
              <div className="story-text-container-full mb-5">
                <div className="story-description" dangerouslySetInnerHTML={{ __html: pageData?.metadata?.read_more_content_1 || 'All of this is coupled with the warmth of appeasing hospitality and a welcoming gesture towards the guests in order to reflect the innate heritage of being responsible emcee. Now Chokhi Dhani comes in the top 10 restaurants in London with his full vintage glory and it spreads Indian culture abroad. It scores third place in the top 10 list and is best known as a Family Restaurant in London, now you can spend great time with your family.' }} />

                <h2 className="story-title" style={{ marginTop: "50px" }}>
                  {pageData?.metadata?.overview_title || 'Chokhi Dhani Group- An overview'}
                </h2>
                <div className="story-divider mx-auto">
                  <span>&#9830;</span>
                  <span>&#9830;</span>
                  <span>&#9830;</span>
                </div>
                <div className="story-description" dangerouslySetInnerHTML={{ __html: pageData?.metadata?.overview_desc_1 || 'Chokhi Dhani’s founder, Gul Vaswani, started the enterprise with intent to preserve and celebrate Rajasthani culture as well as introduce it to local and international travellers. Chokhi Dhani is an established name in India for its innovative theme endeavours situated at various different locations in the country. It hails as a “tasteful and authentic symbol of ethnic village life.”' }} />
                <div className="story-description" dangerouslySetInnerHTML={{ __html: pageData?.metadata?.overview_desc_2 || 'Chokhi Dhani, “a Fine Village or Good Dwelling,” opened near Jaipur in 1990 as a celebration of traditional Rajasthani cuisine. Ever since then, the original restaurant has been serving traditional food amidst a conventional set-up sprinkled with the flavours of pastoral hospitality in order to give contentment to the national and international travellers and explorers.' }} />
                <div className="story-description" dangerouslySetInnerHTML={{ __html: pageData?.metadata?.overview_desc_3 || 'In the pursuit of promoting the deep-seated heritage, culture, rituals, and traditions, Chokhi Dhani operates in a socially responsible environment and aims at preserving the long-lost golden era of ancient Indian life. It reflects the grandeur of the majestic royal era through its fine-dine restaurants as well as acquaints the coming generations with the ancient rural living for a holistic approach towards preserving the heritage.' }} />
                <div className="story-description" dangerouslySetInnerHTML={{ __html: pageData?.metadata?.overview_desc_4 || 'Along the way, Chokhi Dhani has received a number of accolades, including India’s Most Innovative Tourism Project by the Ministry of Tourism and a Five-Star deluxe accreditation for its resort in Jaipur to name a few.' }} />

                <h2 className="story-title" style={{ marginTop: "50px" }}>
                  {pageData?.metadata?.family_title || 'Globally Appreciated Family Restaurant in London'}
                </h2>
                <div className="story-divider mx-auto">
                  <span>&#9830;</span>
                  <span>&#9830;</span>
                  <span>&#9830;</span>
                </div>
                <div className="story-description" dangerouslySetInnerHTML={{ __html: pageData?.metadata?.family_desc_1 || 'Marking the first overseas opening for the group, Chokhi Dhani is the brainchild of extraordinary young chef, hotelier and entrepreneur Kriti Vaswani who is following the footsteps of her father, Gul Vaswani in taking the idea of preserving the heritage of India on a global platform.' }} />
                <div className="story-description" dangerouslySetInnerHTML={{ __html: pageData?.metadata?.family_desc_2 || 'Chokhi Dhani also has Kalagram, a social initiative to promote the art culture of India, wherein the ancient art forms and the artiste are given an international platform to flourish and grow. An extensive range of exclusive handicrafts is available at Chokhi Dhani inclusive of Home Decor, Jewellery, and utility products.' }} />
                <div className="story-description" dangerouslySetInnerHTML={{ __html: pageData?.metadata?.family_desc_3 || 'Each product is handcrafted by the experienced artists working with Chokhi Dhani using traditional techniques. It was conceptualised with a notion to retain and revive the Indian art forms which are dying a slow death in this era of mass production. Chokhi Dhani is a premium fine-dine restaurant and lounge in London.' }} />
              </div>

                            {pageData?.faqs && pageData.faqs.length > 0 && (
                <div className="row text-center mt-5 mb-5" style={{ maxWidth: '800px', margin: '0 auto' }}>
                  <h2 className="story-title" style={{ marginTop: '50px', fontSize: '2.5rem' }}>Frequently Asked Questions</h2>
                  <div className="story-divider mx-auto">
                    <span>&#9830;</span>
                    <span>&#9830;</span>
                    <span>&#9830;</span>
                  </div>
                  <Accordion defaultActiveKey="0" flush className="faq-accordion-custom text-start mt-4">
                    {pageData.faqs.map((faq, index) => (
                      <Accordion.Item eventKey={index.toString()} key={index}>
                        <Accordion.Header>{faq.question}</Accordion.Header>
                        <Accordion.Body>
                          <div dangerouslySetInnerHTML={{ __html: faq.answer }} />
                        </Accordion.Body>
                      </Accordion.Item>
                    ))}
                  </Accordion>
                </div>
              )}

              <button
                onClick={handleShowLess}
                className="btn-story-readmore mt-4"
              >
                Show Less
              </button>
            </div>
          )}
        </div>
      </section>
      <Footer />
    </div>
  );
}
export default AboutUs;
